export enum VariationTipTypes {
  REPHRASE = 'rephrase',
  DIRECT_TRANSLATION = 'direct-translation'
}
